import { render, staticRenderFns } from "./GoalsList.vue?vue&type=template&id=69cf3a0e&scoped=true"
import script from "./GoalsList.vue?vue&type=script&lang=js"
export * from "./GoalsList.vue?vue&type=script&lang=js"
import style0 from "./GoalsList.vue?vue&type=style&index=0&id=69cf3a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cf3a0e",
  null
  
)

export default component.exports